const TOAST_ID = 'loft-error-toast';
const TOAST_DURATION_MS = 5000;

function showToast(message: string, background: string): void {
  const existing = document.getElementById(TOAST_ID);
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = TOAST_ID;
  toast.style.cssText = [
    'position:fixed',
    'top:1rem',
    'right:1rem',
    `background:${background}`,
    'color:#fff',
    'padding:0.75rem 1.25rem',
    'border-radius:6px',
    'font-size:0.85rem',
    'z-index:9999',
    'max-width:400px',
    'box-shadow:0 4px 12px rgba(0,0,0,0.3)',
  ].join(';');
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), TOAST_DURATION_MS);
}

/**
 * Display a non-blocking error toast notification in the top-right corner.
 * Automatically dismisses after 5 seconds. Only one toast is shown at a time.
 */
export function showErrorToast(message: string): void {
  showToast(message, '#dc2626');
}

/** Display a non-blocking informational toast (same placement as the error toast). */
export function showInfoToast(message: string): void {
  showToast(message, '#1a3a6b');
}
